import { useQuery, useQueryClient } from 'react-query';

import { useParams } from 'react-router-dom';

// Our axios Instance
import axiosInstance from 'services/API/API';

// Our Query Keys
import {
	CLIENT_ONBOARDING_ASSETS,
	ERROR_MESSAGE_DATA
} from 'shared/query-keys';

// Our endpoints
import { userAssets } from 'shared/api-urls';

// Utils
import { dataIsValid } from 'shared/utils';

function useGetAssets() {
	const queryClient = useQueryClient();

	const urlParams = useParams();

	const params = {
		clientId: urlParams?.clientId
	};

	const DYNAMIC_QUERY_KEY = dataIsValid(params?.clientId)
		? [CLIENT_ONBOARDING_ASSETS, params?.clientId]
		: CLIENT_ONBOARDING_ASSETS;

	return useQuery(
		DYNAMIC_QUERY_KEY,
		() =>
			axiosInstance
				.get(userAssets, { params })
				.then((res) => res.data.data),
		{
			onError: () => {
				queryClient.setQueryData(
					ERROR_MESSAGE_DATA,
					'We had an issue retrieving your asset information.'
				);
			},
			refetchOnWindowFocus: false
		}
	);
}

export default useGetAssets;
